import { CompanyBasic } from 'src/app/app/company/company.model';

export class Order {
    id: number;
    idUser: number;
    status: number; // słownik
    dateCreated: Date;
    idCompanyProvider: number;
    description: string;
    orderItems: OrderItem[] = [];
    companyProvider: CompanyBasic;
    orderCost: number;
}

export class OrderItem {
    id: number;
    idOrder: number;
    idProduct: number;
    productName: string;
    price: number;
    amount: number;
    totalCost: number;
}

export enum OrderViewMode {
    UserOrders,
    CompanyOrders,
    AllOrders
}